<template>
  <component :is="panel" :user="user"/>
</template>

<script>
import base from '../base'
import CEmptyPanel from './CEmptyPanel'
import CHasPanel from './CHasPanel'

export default {
  name: 'CPaymentPanel',
  mixins: [
    base
  ],
  computed: {
    panel () {
      return this.user.payments ? CHasPanel : CEmptyPanel
    }
  }
}
</script>
